import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom'; // ← UPDATED
import Header from './components/Header';
import FeedPage from './pages/FeedPage';
import PostDetailPage from './pages/PostDetailPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard'; // ← ADDED
import './App.css';

// Base API URL - points to your backend
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
// Admin Route Protection Component ← ADDED
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('adminLoggedIn') === 'true';
  return isAuthenticated ? children : <Navigate to="/admin-login" />;
};

function App() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch posts from backend
  useEffect(() => {
    console.log('🔄 Starting to fetch posts...');
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    try {
      console.log('📡 Making API call to:', `${API_URL}/posts`);
      const response = await fetch(`${API_URL}/posts`);
      console.log('📨 Response status:', response.status);
      console.log('📨 Response ok:', response.ok);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('✅ Data received:', data);
      console.log('✅ Number of posts:', data.length);
      
      setPosts(data);
      setLoading(false);
    } catch (error) {
      console.error('❌ Error fetching posts:', error);
      console.error('❌ Error details:', error.message);
      setLoading(false);
    }
  };

  const addLike = async (postId) => {
    try {
      console.log('👍 Adding like to post:', postId);
      const response = await fetch(`${API_URL}/posts/${postId}/like`, {
        method: 'PATCH'
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const updatedPost = await response.json();
      console.log('✅ Like added:', updatedPost);
      
      // Update the post in local state
      setPosts(posts.map(post => 
        post._id === postId ? updatedPost : post
      ));
    } catch (error) {
      console.error('❌ Error adding like:', error);
    }
  };

  if (loading) {
    return (
      <div className="App">
        <Header />
        <div className="loading" style={{ 
          textAlign: 'center', 
          padding: '2rem',
          fontSize: '1.2rem',
          color: '#666'
        }}>
          Loading posts...
        </div>
      </div>
    );
  }

  console.log('🎯 Rendering with posts:', posts);

  return (
    <div className="App">
      <Header />
      <main className="main-content">
        <Routes>
          <Route 
            path="/" 
            element={<FeedPage posts={posts} onLike={addLike} />} 
          />
          <Route 
            path="/post/:id" 
            element={<PostDetailPage onLike={addLike} />} 
          />
          <Route path="/admin-login" element={<AdminLogin />} />
          {/* Add Protected Admin Route ↓ */}
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </main>
    </div>
  );
}

export default App;